import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BuyPlanComponent } from '../../subscriptions/buy-plan/buy-plan.component';
import { PayComponent } from '../../subscriptions/payments/methods/pay/pay.component';
import { EditComponent } from '../../subscriptions/payments/methods/edit/edit.component';
import { PaymentMethod } from '../models';


@Injectable({
  providedIn: 'root',
})
export class SideDialogService {
  public showDialogSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public sideDialogComponent: BehaviorSubject<{
    component: any;
    data: { [key: string]: any };
  } | null> = new BehaviorSubject<{
    component: any;
    data: { [key: string]: any };
  } | null>(null);


  public showDialog(component:any ,data?:any): void {
    this.sideDialogComponent.next({
      component: component,
      data: data ?? {},
    });
  }


  public showBuyPlanDialog(data?:any): void {
    console.log('showBuyPlanDialog')
    this.sideDialogComponent.next({
      component: BuyPlanComponent,
      data:  data ??{},
    });
  }


  public showPayDialog(): void {
    this.sideDialogComponent.next({
      component: PayComponent,
      data: {},
    });
  }

  public showDifferentMethodDialog(): void {
    this.sideDialogComponent.next({
      component: EditComponent,
      data: { mode: 'different' },
    });
  }

  public showEditMethodDialog(paymentMethod: PaymentMethod): void {
    this.sideDialogComponent.next({
      component: EditComponent,
      data: { mode: 'edit', paymentMethod },
    });
  }

  public showNewMethodDialog(): void {
    this.sideDialogComponent.next({
      component: EditComponent,
      data: { mode: 'new' },
    });
  }
}
